<ng-container *ngIf="labelTypeTranslations$ | async as labelTypeTranslations">
  <hazmatsuite-next-license-dependent-button
    [model]="licenseBtnModel"
    [title]="labelTypeTranslations['LoadFromMyArticles']"
    (beforeNavigationAction)="beforeNavigationAction.next($event)"
    (submitAction)="showArticleSelectionModal = true"
  ></hazmatsuite-next-license-dependent-button>

  <hazmatsuite-next-modal
    [title]="labelTypeTranslations['SelectArticleOrDangerousGood']"
    [cancelButtonLabel]="labelTypeTranslations['Cancel']"
    [showModal]="showArticleSelectionModal"
    modalSize="lg"
    (closeModal)="showArticleSelectionModal = false"
  >
    <hazmatsuite-next-article-selection
      *ngIf="showArticleSelectionModal"
      [transportMode]="transportMode"
      [labelType]="labelTypes.DangerousGoods"
      (selectArticle)="
        showArticleSelectionModal = false; selectArticle.next($event)
      "
    ></hazmatsuite-next-article-selection>
  </hazmatsuite-next-modal>
</ng-container>
